module.exports = __webpack_public_path__ + "static/truebill-b7f155228581174431501cf6bc4e7560.png";